import script from "./PosLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PosLayout.vue?vue&type=script&setup=true&lang=js"

import "./PosLayout.vue?vue&type=style&index=0&id=bd161542&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd161542"]])

export default __exports__